import '../sass/styles.scss';
import 'slick-carousel/slick/slick.js';
import 'dropkickjs/dist/dropkick.js';
import AOS from 'aos/dist/aos.js';


AOS.init({
    once: true,
});


//accordeon


const showAccordeon = (elem, height) => {
    elem.parentElement.classList.add('show');
    elem.style.height = height + "px";
};

const closeAccordeon = (elem) => {
    elem.parentElement.classList.remove('show');
    elem.style.height = "0px";
};

// Selecciona todos los acordeones y agrega el event listener
const accordeons = document.querySelectorAll(".accordeon");

accordeons.forEach(function(accordeon) {
    accordeon.addEventListener('click', (event) => {
        const target = event.target;
        if (target && target.nextElementSibling) {
            const isOpen = target.parentElement.classList.contains("show");
            if (!isOpen) {
                showAccordeon(target.nextElementSibling, target.nextElementSibling.scrollHeight);
            } else {
                closeAccordeon(target.nextElementSibling);
            }
        }
    });
});


//accordeon